import { render, staticRenderFns } from "./appTextEditor.vue?vue&type=template&id=39556fda"
import script from "./appTextEditor.vue?vue&type=script&lang=js"
export * from "./appTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports